import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@sezane/front-components';
import analytics from '../../../../analytics';
import routes from '../../../../routes';
import translate from '../../../../translate';
const AddAlertButton = ({ soon = false, tracking }) => (_jsx("span", { className: "c-tooltip c-tooltip--secondary c-tooltip--full js-create-alert-button", children: _jsx(Button, { color: "alert", className: "c-tooltip__trigger", fullWidth: true, "data-component": "dialog", "data-modal-url": routes.user_alert_add_ajax, "data-form": "form[data-cart-add-product]", "data-query": `soon=${soon.toString()}`, "data-target": "ajax-modal2", onClick: () => {
            tracking && analytics.productAlert(tracking);
        }, children: translate('front.product.index.createAlert') }) }));
export default AddAlertButton;
